/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  InvestorProfileResult,
  QuestionnaireConfig,
  QuestionnaireEvaluateRequestAnswers,
  QuestionnaireEvaluateResult,
  QuestionnaireQuestions,
  Questions,
  UserAnswersRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InvestorProfileResultFromJSON,
    InvestorProfileResultToJSON,
    QuestionnaireConfigFromJSON,
    QuestionnaireConfigToJSON,
    QuestionnaireEvaluateRequestAnswersFromJSON,
    QuestionnaireEvaluateRequestAnswersToJSON,
    QuestionnaireEvaluateResultFromJSON,
    QuestionnaireEvaluateResultToJSON,
    QuestionnaireQuestionsFromJSON,
    QuestionnaireQuestionsToJSON,
    QuestionsFromJSON,
    QuestionsToJSON,
    UserAnswersRequestFromJSON,
    UserAnswersRequestToJSON,
} from '../models/index';

export interface PostInvestorProfileApimPostRequest {
    questionnaireEvaluateRequestAnswers: QuestionnaireEvaluateRequestAnswers;
}

export interface PostInvestorProfilePostRequest {
    userAnswersRequest: UserAnswersRequest;
}

/**
 * 
 */
export class InvestorProfileApi extends runtime.BaseAPI {

    /**
     * Get questions for investment profile
     */
    async getInvestorProfileQuestionsApimGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionnaireQuestions>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/investor-profile/v2/questions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionnaireQuestionsFromJSON(jsonValue));
    }

    /**
     * Get questions for investment profile
     */
    async getInvestorProfileQuestionsApimGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionnaireQuestions> {
        const response = await this.getInvestorProfileQuestionsApimGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get questions for investment profile
     * @deprecated
     */
    async getInvestorProfileQuestionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Questions>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/investor-profile/questions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestionsFromJSON));
    }

    /**
     * Get questions for investment profile
     * @deprecated
     */
    async getInvestorProfileQuestionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Questions>> {
        const response = await this.getInvestorProfileQuestionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get questionnaire config for investment profile (funds, profiles, strategies)
     */
    async getInvestorQuestionnaireConfigGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionnaireConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/investor-profile/questionnaire-config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionnaireConfigFromJSON(jsonValue));
    }

    /**
     * Get questionnaire config for investment profile (funds, profiles, strategies)
     */
    async getInvestorQuestionnaireConfigGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionnaireConfig> {
        const response = await this.getInvestorQuestionnaireConfigGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resolve answers for investment profile questions
     */
    async postInvestorProfileApimPostRaw(requestParameters: PostInvestorProfileApimPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuestionnaireEvaluateResult>> {
        if (requestParameters['questionnaireEvaluateRequestAnswers'] == null) {
            throw new runtime.RequiredError(
                'questionnaireEvaluateRequestAnswers',
                'Required parameter "questionnaireEvaluateRequestAnswers" was null or undefined when calling postInvestorProfileApimPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/investor-profile/v2/resolve-answers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionnaireEvaluateRequestAnswersToJSON(requestParameters['questionnaireEvaluateRequestAnswers']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestionnaireEvaluateResultFromJSON(jsonValue));
    }

    /**
     * Resolve answers for investment profile questions
     */
    async postInvestorProfileApimPost(requestParameters: PostInvestorProfileApimPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuestionnaireEvaluateResult> {
        const response = await this.postInvestorProfileApimPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve answers for investment profile questions
     * @deprecated
     */
    async postInvestorProfilePostRaw(requestParameters: PostInvestorProfilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestorProfileResult>> {
        if (requestParameters['userAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'userAnswersRequest',
                'Required parameter "userAnswersRequest" was null or undefined when calling postInvestorProfilePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/investor-profile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserAnswersRequestToJSON(requestParameters['userAnswersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestorProfileResultFromJSON(jsonValue));
    }

    /**
     * Resolve answers for investment profile questions
     * @deprecated
     */
    async postInvestorProfilePost(requestParameters: PostInvestorProfilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestorProfileResult> {
        const response = await this.postInvestorProfilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
